import { createFileRoute, Outlet } from '@tanstack/react-router';
import { RiskActionPlan } from '../RiskActionPlan';
import { useRiskEditAccess } from '../useRiskEditAccess';

export const Route = createFileRoute('/console/$orgId/risk/register/details/$id/action-plan')({
    component: RouteComponent,
});

function RouteComponent() {
    const { id } = Route.useParams();
    const { canEdit, canEditActionPlans } = useRiskEditAccess();

    return (
        <>
            <RiskActionPlan riskId={id} readonly={!canEditActionPlans} canCreate={canEdit} />
            <Outlet />
        </>
    );
}
